// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class ReportGroupRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_REPORT_GROUP_REQUEST, fieldSet);
    }
    setReportId(id) {
        this.setFieldValue(FieldsFactory.FIELD_REPORT_ID, id);
    }
    setLanguage(language) {
        this.setFieldValue(FieldsFactory.FIELD_LANG, language);
    }
    setIsTechnicalReport(isTechnical) {
        this.setFieldValue(FieldsFactory.FIELD_IS_TECHNICAL_REPORT, isTechnical);
    }
}
